// extracted by mini-css-extract-plugin
export default {"footer":"style_footer__hnca0","footer-pp":"style_footer-pp__zqerw","bottom-wave":"style_bottom-wave__Nyzc7"};